import Location from './Location'

export default class Atlanta extends Location { }

Atlanta.defaultProps = {
    locationTown: "Kennesaw",
    headInstructor: "Greg Kendall, Master",
    mapLink: "",
    locationName: "Lost Mountain area of Kennesaw, GA",
    address1: "",
    cityStateZip: "",
    classTimes:"Not currently accepting students",
    class1: "",
    registrationStatus: "Email us to be added to our new student waiting list",
    registrationMonthly: "",
    infoEmail: "mailto:info.kennesaw@warriors-for-christ.com?subject=Warriors Martial Arts Classes",
    calendarLink: '',
    instructor: "/kendallg"
};
